<div class="holder" [class.height]="!noDrag">
  <spb-file-upload
    [multiple]="true"
    buttonStyle="outlined"
    icon="note_add"
    [noDrag]="noDrag"
    [fileTypes]="'.txt,.pdf,.png,.jpg,.jpeg,.doc,.docx,.rtf,.odt'"
    [text]="service.createdDocuments().length > 0 ? 'Lägg till fler dokument' : 'Tryck här för att ladda upp dokument'"
    encoding="Blob"
    (files)="files.emit($event)">
  </spb-file-upload>
</div>
